<div class="container">
  <div class="col-md-12 text-danger">
    <fa-icon [icon]="faExclamationTriangle" size="3x"></fa-icon>
    <h1>Erreur de communication avec le serveur</h1>
  </div>
</div>
